import { config } from "config";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";
import { CompanyContactState } from ".";

const default_page_size = config.PAGE_SIZE;

const initialState: CompanyContactState = {
	companyContacts: [],
	companyContact: null,
	loading: true,
  filters: { page: 1, page_size: default_page_size },
  count: 0,
  refresh: 0,
  refreshLoader: false,
  current_filters: { },
};

export const companyContactSlice = createSlice({
  name: "companyContact",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
    },
    setCompanyContacts: (state, action) => {
      const { companyContacts, count } = action.payload;
      let options: SelectOption[] = [];
      companyContacts.forEach(({ _id, name,email,position }: any) =>
        options.push({ value: _id, label: name })
      );
      state.companyContacts = companyContacts;
      state.count = count;
      state.refreshLoader = false;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    updatCompanyContact: (state, action) => {
      const { id, detailContact } = action.payload;
      state.companyContacts.every(({ _id }, i) => {
        if (id === _id) {
          state.companyContacts[i] = detailContact;
          return false;
        }
        return true;
      });
    },
    setCompanyContact: (state, action) => {
      state.companyContact = action.payload;
    },
    addCompanyContact: (state, action) => {
      state.companyContacts.unshift(action.payload);
    },
    deleteCompanyContacts: (state, action) => {
      const id = action.payload;
      state.companyContacts = state.companyContacts.filter(
        ({ _id }) => id !== _id
      );
    },
  },
});

const companyContactReducer = companyContactSlice.reducer;

export const companyContactActions = companyContactSlice.actions;
export default companyContactReducer;
